import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SourceLocationService {
  #sourceUrlKey = 'academy_oauth_source_url';

  store() {
    localStorage.setItem(this.#sourceUrlKey, window.location.pathname);
  }

  get() {
    return localStorage.getItem(this.#sourceUrlKey);
  }

  clear() {
    localStorage.removeItem(this.#sourceUrlKey);
  }
}
